<template>

  <div class="tabs container" ref="tabsContainer">
    <ul class="tabs-container">
      <li @click="activeTab = 'tabRisposta'" class="w-1/2" :class="{'active': activeTab === 'tabRisposta'}">
        <span class="align-middle uppercase !text-[13px]">Risposta</span>
        <div class="needToSaveDot" :class="{'!inline-block': rispostaEdited}"></div>
      </li>
      <li @click="activeTab = 'tabNota'" class="w-1/2" :class="{'active': activeTab === 'tabNota'}" v-if="!hide_nota_interna && (ruolo == 'admin' || ruolo == 'dipendente')">
        <span class="align-middle uppercase !text-[13px]"> Nota Interna</span>
        <div class="needToSaveDot" :class="{'!inline-block': notaEdited}"></div>
      </li>
    </ul>
    <div id="tabRisposta" class="tab-content" :class="{'hidden': activeTab !== 'tabRisposta'}">

      <FormInput :dati='infoRisposta'
                   :formlabel="labelRisposta"
                   :stilestruttura="style"
                   :idform="idform"
                   :action="action"
                   :recaptcha="recaptcha"
                   @aiHelp="(e)=>riscriviAi(e)"
                   @selectChanged="handleSelectChange"
                   ref="inputRisposta">
        </FormInput>
    </div>
    <div id="tabNota" class="tab-content" :class="{'hidden': activeTab !== 'tabNota'}" v-if="!hide_nota_interna && (ruolo == 'admin' || ruolo == 'dipendente')">

      <FormInput :dati='infoNota'
                   :formlabel="labelNota"
                   :stilestruttura="style"
                   :idform="idform"
                   :action="action"
                   :recaptcha="recaptcha"
                   @selectChanged="handleSelectChange"
                   ref="inputNota">
        </FormInput>
    </div>

  </div>
  <FormInput :dati='info'
                 :formlabel="label"
                 stilestruttura="hidden"
                 :idform="idform"
                 :action="action"
                 :recaptcha="recaptcha"
                 @selectChanged="handleSelectChange"
                 ref="input">
      </FormInput>


    <ConfirmDialog></ConfirmDialog>

    <Dialog
      modal
      v-model:visible="visibleComposeWithAi"
      header="Correggi con AI"
      :style="{ width: '60vw', maxHeight: '90vh', minWidth: '800px' }"
      :dismissableMask="true"
      pt:root:class="ai-assistant-modal"
    >
      <!-- Loading indicator -->
      <div v-if="loading" class="w-full flex flex-col items-center justify-center p-6">
          <div class="message-header">
              <i class="pi pi-sparkles"></i>
          </div>
          <div class="message-content">
              <i class="pi pi-spin pi-spinner"></i> {{ $root.trans.sto_pensando }}
          </div>
      </div>
      <div v-else v-html="aiFixedContent" class="rounded-sm bg-slate-100 p-4 max-h-[60vh] overflow-y-auto">

      </div>
      <template #footer>
        <div class="flex justify-between items-center">

          <Button
            label="Annulla"
            @click="()=>annullaCorrezione()"
            severity="secondary"

          />
          <Button
            label="Accetta Correzione"
            @click="()=>accettaCorrezione()"

          />
        </div>
      </template>
    </Dialog>

</template>
<style>

</style>
<script>


import FormInput from './FormInput.vue';
import  ConfirmDialog  from 'primevue/confirmdialog';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import {usePlan} from '../usePlan';

export default {
  name: "InnerThreadForm",
  components: {
    FormInput,
    Dialog,
    ConfirmDialog,
    Button

  },
  props: [
    'dati',
    'struttura',
    'azione',
    'annulla',
    'stilestruttura',
    'id',
    'recaptcha',
    'bottonesalva',
    'bottonesalvacontinua',
    'bottoneannulla',
    'oretotali',
    'is_completato',
    'linkriapertura',
    'hide_riapri',
    'ruolo',
    'hide_nota_interna'
  ],
  data() {
    return {
      cancel: this.annulla,
      action: this.azione,
      info: JSON.parse(this.dati),
      label: JSON.parse(this.struttura),
      style: this.stilestruttura,
      errors: {},
      imginput: false,
      idform: this.id,
      activeTab: 'tabRisposta',
      infoRisposta: {},
      infoNota: {},
      labelRisposta: {},
      labelNota: {},
      rispostaEdited: false,
      notaEdited: false,
      visibleComposeWithAi: false,
      loading: false,
      aiFixedContent: '',
      isRiaprendo: false,
    };
  },
  watch:{
    'infoRisposta.messaggio'(newRisposta){
      const trimmedNewRisposta = newRisposta.replace(/(<([^>]+)>)/gi, "").trim();
      if(trimmedNewRisposta != ''){
        this.rispostaEdited = true;
      }else if(trimmedNewRisposta == '' && this.infoRisposta.ore == 0 && this.infoRisposta.ticketingstato_id == this.info.ticketingstato_id){
        this.rispostaEdited = false;
      }
    },
    'infoRisposta.ore'(newOre){
      const trimmedNewRisposta = this.infoRisposta.messaggio.replace(/(<([^>]+)>)/gi, "").trim();
      if(newOre != 0){
        this.rispostaEdited = true;
      }else if(newOre == 0 && trimmedNewRisposta == '' && this.infoRisposta.ticketingstato_id == this.info.ticketingstato_id){
        this.rispostaEdited = false;
      }
    },
    'infoRisposta.ticketingstato_id'(newStato){
      const trimmedNewRisposta = this.infoRisposta.messaggio.replace(/(<([^>]+)>)/gi, "").trim();
      if(newStato != this.info.ticketingstato_id){
        this.rispostaEdited = true;
      }else if(newStato == this.info.ticketingstato_id && trimmedNewRisposta == '' && this.infoRisposta.ore == 0){
        this.rispostaEdited = false;
      }
    },
    'infoNota.nota_interna'(newNota){
      const trimmedNewNota = newNota.replace(/(<([^>]+)>)/gi, "").trim();
      if(trimmedNewNota != ''){
        this.notaEdited = true;
      }else{
        this.notaEdited = false;
      }
    }

  },
  beforeMount() {
    if (typeof this.id == "undefined") {
      this.idform = 'maschera';
    } else {
      this.idform = this.id;
    }
    this.splitInfo();


  },
  mounted() {
    document.addEventListener('formChanged', function(e){
      this.label = e.detail.newStruttura;
    });

  },
  methods: {
    async riscriviAi(e){

      this.loading = true;
      this.visibleComposeWithAi = true;
      axios.post(`/${this.ruolo}/ticketing/fix-message`, {
        message: e.value,
      }).then((res)=>{
        this.loading = false;
        this.aiFixedContent = res.data.fixed_message;
      }).catch((err)=>{
        this.loading = false;
        this.aiFixedContent = err.response.data.fixed_message;
      })
    },
    accettaCorrezione(){
      this.infoRisposta.messaggio = this.aiFixedContent;
      this.$refs.inputRisposta.info['messaggio'] = this.aiFixedContent;
      this.visibleComposeWithAi = false;
      this.aiFixedContent = '';
    },
    annullaCorrezione(){
      this.visibleComposeWithAi = false;
      this.aiFixedContent = '';
    },
    async submitForm(){
      const hasNotaInterna = !this.hide_nota_interna && (this.ruolo == 'admin' || this.ruolo == 'dipendente');
      const allegatiNota = hasNotaInterna ? this.infoNota.allegati : [];
      const allegati = [...this.infoRisposta.allegati, ...allegatiNota];
      this.info = Object.assign(this.info, this.infoRisposta, hasNotaInterna ? this.infoNota : {});
      this.info.allegati = allegati;
      // aggiungere verifiche ai due form
      const erroriRisposta = await this.$refs.inputRisposta.checkForm(3);
      const erroriNota = hasNotaInterna ? await this.$refs.inputNota.checkForm(3) : false;

      if(!erroriRisposta && !erroriNota){
        this.$refs.input.sendForm(0);
      }

      //this.$refs.input.checkForm(0)
    },
    async riapriTicket(){
      if (this.isRiaprendo) return;
      try{
        // prima controllo se il form è compilato correttamente
        const hasErrors = await this.$refs.inputRisposta.checkForm(3);
        //se non ci sono errori procedo prima con la clonazione del ticket
        if(!hasErrors){
          this.isRiaprendo = true;
          const riapriCode = new URLSearchParams(window.location.search).get('code');
          axios.post(this.linkriapertura, { code: riapriCode })
            .then((response) =>{
               if (response.data.success){

                 this.$toast.add({
                      severity: 'success',
                      summary: this.$root.trans.success_form,
                      detail: this.$root.trans.salvataggio_success,
                      life: 3000
                    });
                    // a questo punto aggiorno l'id del ticket nei data
                    // dopo di che salvo il form
                    this.infoRisposta.ticketing_id = response.data.ticketing_id;
                    this.info.ticketing_id = response.data.ticketing_id;
                    this.infoRisposta.ticketingstato_id = response.data.in_lavorazione_id;
                    this.info.ticketingstato_id = response.data.in_lavorazione_id;
                    this.submitForm();

               }else{
                this.isRiaprendo = false;
                if (response.data.message != null) {
                    this.$toast.add({
                      severity: 'errors',
                      summary: this.$root.trans.errors_form,
                      detail: this.$root.trans[response.data.message],
                      life: 5000
                    });
                  } else {
                    this.$toast.add({
                      severity: 'errors',
                      summary: this.$root.trans.errors_form,
                      detail: this.$root.trans.salvataggio_errato,
                      life: 3000
                    });
                  }
               }
            })
        }
      }catch(error){
        this.isRiaprendo = false;
        if (error.response && error.response.status === 401) {
          this.$toast.add({
            severity: 'errors',
            summary: this.$root.trans.errors_form,
            detail: this.$root.trans.salvataggio_errato,
            life: 3000
          });
        }
      }
    },
    handleSelectChange(e,d){
      if(d == 'malware_confermato'){
        const newStruttura = {...this.labelRisposta};
        newStruttura['malware_tipo'][1] = this.infoRisposta.malware_confermato == 4 ? 'checkbox-multipla' : 'hidden';
        this.labelRisposta = newStruttura
      }
    },
    checkOre() {

      const ore = this.oretotali + this.infoRisposta['ore'];
      if(this.infoRisposta['ticketingstato_id'] == 5 && ore == 0){
        this.$confirm.require({
          message: this.$root.trans.conferma_ticket_zero_ore,
          header: this.$root.trans.conferma_ticket_zero_ore_titolo,
          rejectProps:{
              label: this.$root.trans.reject
          },
          acceptProps:{
              label: this.$root.trans.accept
          },
          accept: ()=>{
              //this.$refs.input.checkForm(0)
              this.submitForm();

          },
          reject: ()=>{

          }
      })
      }else{
        console.log('dovrei checkare il form')
        //this.$refs.input.checkForm(0)
        this.submitForm();
      }
    },
    splitInfo(){
      if(this.ruolo == 'admin' || this.ruolo == 'dipendente'){
        const { can } = usePlan();
        if(!can('ai_tecnici')){
          this.label.messaggio[1] = 'textarea';
        }
        this.infoRisposta = {
          ticketing_id: this.info.ticketing_id,
          messaggio: this.info.messaggio,
          allegati: this.info.allegati,
          ticketingstato_id: this.info.ticketingstato_id,
          ore: this.info.ore,
          tipologia_ore: this.info.tipologia_ore,
          nuovi_collaboratori: this.info.nuovi_collaboratori,
          collaboratori: this.info.collaboratori,
          trasferta: this.info.trasferta,
          invio_notifica: this.info.invio_notifica,
          ...(this.info.malware_confermato !== undefined ? { malware_confermato: this.info.malware_confermato } : {}),
          ...(this.info.malware_tipo !== undefined ? { malware_tipo: this.info.malware_tipo } : {}),
        }
        this.infoNota = {
          ticketing_id: this.info.ticketing_id,
          nota_interna: this.info.nota_interna,
          allegati: this.info.allegati,
          invio_notifica_nota_interna: this.info.invio_notifica_nota_interna
        }
        this.labelRisposta = {
          messaggio: this.label.messaggio,
          allegati: this.label.allegati,
          ticketingstato_id: this.label.ticketingstato_id,
          ore: this.label.ore,
          tipologia_ore: this.label.tipologia_ore,
          ...(this.label.malware_confermato ? {
            malware_confermato: this.label.malware_confermato,
            malware_tipo: this.label.malware_tipo,
          } : {}),
          collaboratori: this.label.collaboratori,
          nuovi_collaboratori: this.label.nuovi_collaboratori,
          trasferta: this.label.trasferta,
          invio_notifica: this.label.invio_notifica,
        }
        this.labelNota = {
          nota_interna: this.label.nota_interna,
          allegati: this.label.allegati,
          invio_notifica_nota_interna: this.label.invio_notifica_nota_interna
        }
      }
      else if(this.ruolo == 'assistenza'){
        this.infoRisposta = {
          assistenza_id: this.info.assistenza_id,
          messaggio: this.info.messaggio,
          allegati: this.info.allegati,
        }
        this.labelRisposta = {
          messaggio: this.label.messaggio,
          allegati: this.label.allegati,
        }
      }
      else{
        this.infoRisposta = {
          ticketing_id: this.info.ticketing_id,
          messaggio: this.info.messaggio,
          allegati: this.info.allegati,
          collaboratori: this.info.collaboratori,
        }
        this.labelRisposta = {
          ticketing_id: this.label.ticketing_id,
          messaggio: this.label.messaggio,
          allegati: this.label.allegati,
          collaboratori: this.label.collaboratori,
        }
      }
    }


  }
}
</script>

<style scoped>
@media (min-width: 768px) {
  :deep([data-field="malware_confermato"]),
  :deep([data-field="invio_notifica"]) {
    grid-column-start: 2;
  }
}
</style>
